import React, { useEffect, useState } from 'react';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import HoursTable from './table/hoursTable';
import { CardListAction } from '../../../../../common/components/cards';
import { HoursDto, hoursInit } from './hours.dtos';
import HoursDialog from './form/hoursDialog';
import { useDispatch } from 'react-redux';
import { rootSelector } from '../../../../../common/selectors/selectors';
import { getType } from 'typesafe-actions';
import {
  createDayActions,
  daysActions,
  deleteDayAction,
  updateDayActions,
} from './hours.actions';
import { MuseumsEnum_class } from '../../../../../common/enums/museums';
import DeleteDialog from '../../../../../common/components/dialog/DeleteDialog';

const HoursCards = () => {
  const dispatch = useDispatch();

  const systemDays = rootSelector((state) => state.days.list);

  const [sloanHours, setSloanHours] = useState<HoursDto[]>([]);
  const [longwayHours, setLongwayHours] = useState<HoursDto[]>([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState<HoursDto>(hoursInit);

  useEffect(() => {
    dispatch({ type: getType(daysActions.request) });
  }, [dispatch]);

  useEffect(() => {
    setSloanHours(
      systemDays.filter((d) => d.museumId === MuseumsEnum_class.enum.Sloan)
    );
    setLongwayHours(
      systemDays.filter((d) => d.museumId === MuseumsEnum_class.enum.Longway)
    );
  }, [systemDays]);

  const openHoursDialog = (value: HoursDto, museum: number) => {
    value.museumId = museum;
    setSelectedDay(value);
    setDialogOpen(true);
  };

  const handleDialogSave = (values: HoursDto) => {
    let allNew = values.id === '';

    dispatch({
      type: allNew
        ? getType(createDayActions.request)
        : getType(updateDayActions.request),
      payload: { ...values },
    });

    setDialogOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogDelete = async (day: HoursDto) => {
    await deleteDayAction(day);

    dispatch({ type: getType(daysActions.request) });

    setDeleteDialogOpen(false);
    setDialogOpen(false);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const openDeleteDialog = () => {
    setDeleteDialogOpen(true);
  };

  return (
    <Grid container spacing={2}>
      {deleteDialogOpen ? (
        <DeleteDialog
          open={deleteDialogOpen}
          onDelete={handleDialogDelete}
          onClose={handleDeleteDialogClose}
          value={selectedDay}
        />
      ) : null}
      {dialogOpen ? (
        <HoursDialog
          dialogOpen={dialogOpen}
          onSave={handleDialogSave}
          onClose={handleDialogClose}
          hours={selectedDay}
          openDeleteDialog={openDeleteDialog}
        />
      ) : null}
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid
              container
              item
              xs={12}
              alignItems='center'
              justify='space-between'
            >
              <Typography variant='h6'>Sloan Hours of Operation</Typography>
              <CardListAction
                key='Add Sloan hours'
                onClick={() => {
                  openHoursDialog(hoursInit, MuseumsEnum_class.enum.Sloan);
                }}
                tooltip='Add Sloan hours'
              />
            </Grid>
            <HoursTable hours={sloanHours} editDay={openHoursDialog} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid
              container
              item
              xs={12}
              alignItems='center'
              justify='space-between'
            >
              <Typography variant='h6'>Longway Hours of Operation</Typography>
              <CardListAction
                key='Add Longway hours'
                onClick={() => {
                  openHoursDialog(hoursInit, MuseumsEnum_class.enum.Longway);
                }}
                tooltip='Add Longway hours'
              />
            </Grid>
            <HoursTable hours={longwayHours} editDay={openHoursDialog} />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default HoursCards;
